export const attempt_login = () => ({
	type: 'ATTEMPT_LOGIN',
});

export const login_completed = user_details => ({
  	type: 'LOGIN_COMPLETED',
  	payload: user_details,
});

export const user_details_fetched  = user_details => ({
  	type: 'USER_DETAILS_FETCHED',
  	payload: user_details,
});

export const fetch_user_details = () => (dispatch) => 
	fetch(global.config.server_path+'user/get_details', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include'})
	.then(resp => resp.json())
	.then(resp => validate_response(resp))
	.then(resp => dispatch(user_details_fetched(resp.data)))
	.catch(err => dispatch(user_details_fetched(null)));

export const local_signup = (email, password, name) => (dispatch) => {
	var url = global.config.server_path+'user/local_signup';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({email, password, name})})
	.then(resp => resp.json())
	.then(resp => {
		console.log('login call =======> ', resp)
		return Promise.resolve(resp.data);
	})
	.catch(err => Promise.reject(err))
};

export const logout = () => (dispatch) => {
	return fetch(global.config.server_path+'user/logout', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include'})
};

export const local_login = (email, password) => (dispatch) => {
	var url = global.config.server_path+'user/local_login';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({email, password})})
	.then(resp => resp.json())
	.then(resp => {
		console.log('login call =======> ', resp)
		return Promise.resolve(resp.data);
	})
	.catch(err => Promise.reject(err))
};


export const forgot_password = (email) => (dispatch) => {
	var url = global.config.server_path + 'user/forgot_password';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({email})})
	.then(resp => resp.json())
	.then(resp => validate_response(resp))
	.catch(err => Promise.reject(err))
};


export const verify_otp = (otp) => (dispatch) => {
	var url = global.config.server_path + 'user/verify_otp';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({otp})})
	.then(resp => resp.json())
	.then(resp => validate_response(resp))
	.catch(err => Promise.reject(err))
};


export const reset_password = (email, password, otp) => (dispatch) => {
	var url = global.config.server_path + 'user/reset_password';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({email, password, otp})})
	.then(resp => resp.json())
	.then(resp => validate_response(resp))
	.catch(err => Promise.reject(err))
};


// export const login = (email,password, mode) => (dispatch) => {
//   	console.log('trying login', email, password, mode)
//   	dispatch(attempt_login());
//   	var url = global.config.server_path+'user/local_login'
//   	if (mode != "login") {
//   		url = global.config.server_path+'user/local_signup'
//   	}
// 	fetch(url, {method: 'POST',cache: "no-store", headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({email, password})})
// 	.then(resp => resp.json())
// 	.then(resp => {
// 		console.log('login response =======> ', resp)
		
// 		dispatch(login_completed(resp.data));
// 	})
// 	.catch(err => {
// 		console.log('err', err)
// 	})
// };

export const show_registration_form = () => ({
	type: 'REGISTER'
})

export const show_login_form = () => ({
	type: 'LOGIN'
})

export const show_forgot_password_form = () => ({type: 'FORGOT_PASSWORD'})

var validate_response = (response) => response.response_code===1?Promise.resolve(response):Promise.reject(response.error)